// Recovered compiled webpack factory 55389. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { y: () => o });
  var n = i(68894),
    s = i(44807),
    r = i(31739);
  let o = {
    test: (t) => r.B.test(t) || n.u.test(t) || s.V.test(t),
    parse: (t) => (r.B.test(t) ? r.B.parse(t) : s.V.test(t) ? s.V.parse(t) : n.u.parse(t)),
    transform: (t) =>
      "string" == typeof t ? t : t.hasOwnProperty("red") ? r.B.transform(t) : s.V.transform(t),
    getAnimatableNone: (t) => {
      let e = o.parse(t);
      return ((e.alpha = 0), o.transform(e));
    },
  };
}
